// AI Upgraded Service
import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ComplianceService } from '@client/app/blocks/service/compliance/compliance.service';
import { HistoryHelperService } from '@client/app/blocks/helpers/history.helper.service';
import { MonNumberPipe } from '@monsido/ng2/core/locale/pipes/mon-number.pipe';
import { DatePipe } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class ExporterPolicyParserService {
    constructor (
        private readonly translateService: TranslateService,
        private readonly complianceService: ComplianceService,
        private readonly historyHelperService: HistoryHelperService,
        private readonly monNumberPipe: MonNumberPipe,
        private readonly datePipe: DatePipe,
    ) {}

    parse (data: any[]): any[] {
        if (!data?.length) {
            return [];
        }

        const csv: string[][] = [];

        csv.push(this.getHeadlines());

        data.forEach((item) => {
            const entry: any[] = [];
            entry.push(this.datePipe.transform(item.post_processing_done_at ?? item.date, 'MMM d, y, h:mm a'));
            entry.push(item.page_count);
            entry.push(item.documents_count);
            entry.push(this.getCompliance(item));
            entry.push(item.policy_with_violations_count);
            entry.push(item.policy_with_required_count);
            entry.push(this.historyHelperService.getCaretCharacter(item.changeValueIconClass) + ' ' + item.changePercentageValue);

            csv.push(entry);
        });

        return csv;
    }

    private getHeadlines (): string[] {
        return [
            this.translateService.getString('Crawled at'),
            this.translateService.getString('Pages crawled'),
            this.translateService.getString('Documents crawled'),
            this.translateService.getString('Domain compliance'),
            this.translateService.getString('Policies - violations'),
            this.translateService.getString('Policies - required'),
            this.translateService.getString('Changes since previous crawl'),
        ];
    }

    private getCompliance (item: any): string {
        item.policyComplianceData ??= this.complianceService.policyHistoryCompliance(item);
        return this.monNumberPipe.transform(item.policyComplianceData?.[0] / 100, '0.[00]%') || '';
    }

    private getCaret (id: any, data: any[], issuesStack: string[]): string {
        const value = this.historyHelperService.getChangeValue(id, data, issuesStack);
        if (value > 0) {
            return String.fromCharCode(94);
        } else if (value < 0) {
            return 'ˇ';
        }
        return '';
    }
}
